<template>
    <div>
        <BenefitsUrgentCareCategories />
        <BenefitsMedClinicCategories />
        <BenefitsHospitalCategories />
        <BenefitsCategories />
    </div>
</template>